export const MOVIE_EXPERIENCE_CONTENT = {
    PREMIUM: {
        img: "diamond_pink.svg",
        img1: "diamond_pink.svg",
        title: "Premium Experience",
        filmPageTitle: "Premium Experience Ticket",
        description: [
            'One Film Ticket',
            'First of its kind Immersive Experience',
            'Exclusive T-shirt for Premium Experience ticket holders',
            'The Phoenician Scheme Combo (Large Popcorn, Any beverage of your choice (including a special signature champagne cocktail) and King Size HERSHEY’S Chocolate Bar) *Valid ID Required if guest selects a Beer or Wine Beverage.'
        ],
        class:'premium'
    },
    STANDARD: {
        img: "ticket_blue.svg",
        img1: "ticket_grey.svg",
        title: "Standard Experience",
        filmPageTitle: "Standard Experience Ticket",
        description: [
            'One Film Ticket',
            'First of its kind Immersive Experience'
        ],
        class:'standard'
    }
}

export const MOVIE_EXPERIENCE_CONTENT_NEW = {
    PREMIUM: {
        img: "diamond_pink.svg",
        img1: "diamond_pink.svg",
        title: "Premium Experience",
        filmPageTitle: "Premium Experience Ticket",
        description: [
            'Admission to the film, access to the immersive experience, an Angelika exclusive t-shirt'
        ],
        class:'premium'
    },
    STANDARD: {
        img: "ticket_blue.svg",
        img1: "ticket_grey.svg",
        title: "Standard Experience",
        filmPageTitle: "Standard Experience Ticket",
        description: [
            'One Film Ticket',
            'First of its kind Immersive Experience'
        ],
        class:'standard'
    }
}


export const NEW_PREMIUM_DATE = "2025-06-06";